import { render, staticRenderFns } from "./ViewVillage.vue?vue&type=template&id=6d20a642"
import script from "./ViewVillage.vue?vue&type=script&lang=js"
export * from "./ViewVillage.vue?vue&type=script&lang=js"
import style0 from "./ViewVillage.vue?vue&type=style&index=0&id=6d20a642&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports